import React from 'react';
import PDFViewer from './PDFViewer';

const MenuView = ({ onClose }) => {
    return (
        <PDFViewer
            pdfUrl="stem_menu.pdf"
            onClose={onClose}
            title="STEM Academy Menu"
        />
    );
};
//frontend\frontend\public\stem_menu.pdf
export default MenuView;